import React, { Component } from "react";
import { connect } from "react-redux";

import Page from "../../components/Page";
import ColorPicker from '../../components/ColorPicker';
import showSecondarySidebar from "../../components/Layout/helpers/showSecondarySidebar";

import { PrimaryButton } from "../../components/Button";
import { goBackToPrev } from "../../navigation/navigationService";
import { 
    VEHICLE_GROUP_COLORS,
    DEFAULT_VEHICLE_GROUP_HEXCODE,
} from "../../../../constants";
import {
    Form,
    Input,
    Button,
    Select,
    message,
} from "antd";

// Redux Actions
import { edit_vehicle_group } from "../../services/redux/actions/vehicleGroups";

const FormItem = Form.Item;

class EditVehicleGroup extends Component {
    state = {
        selectedVG: {},
        colorHexCode: DEFAULT_VEHICLE_GROUP_HEXCODE,

        // Search Stuff
        searchedVehicleNameString: "",
    }

    keySeperator = " - ";

    submitForm = () => {
        let isValid = true;

        if (!this.state.selectedVG.groupName) {
            message.error("Please Enter The Vehicle Group's Name");

            isValid = false;
        }

        if (!this.state.selectedVG.colorHexCode) {
            message.error("Please Enter A Vehicle Color For The Vehicle Group");

            isValid = false;
        }

        if (isValid) {
            this.setState({ 
                isLoading: true 
            },
                () => {
                    // console.log("Editing Vehicle Group:", this.state.selectedVG);
        
                    this.props.dispatch(edit_vehicle_group(this.state.selectedVG))
                    .then(() => {
                        this.props.dispatch(goBackToPrev());

                        this.setState({ isLoading: false });
                    })
                }
            );
        }
    }

    setUpSelectedVG = () => {
        const selectedVG = this.props.vehicleGroups.byVGID[this.props.router.location.state.selectedVGID];
        
        this.setState({
            selectedVG: {
                ...selectedVG,
                vehicles:
                    selectedVG.vehicles
                    .sort((a, b) => {
                        const vA = this.props.vehicles.byId[a].vehicleDisplayName.toLowerCase();
                        const vB = this.props.vehicles.byId[b].vehicleDisplayName.toLowerCase();

                        if (vA < vB) return -1;
                        if (vA > vB) return 1;
                        return 0;
                    })
            },
        })
    }

    componentDidMount = () => {
        if (Object.keys(this.props.vehicles.byId).length && Object.keys(this.props.vehicleGroups.byVGID).length) {
            this.setUpSelectedVG();
        }
    }

    componentDidUpdate = (prevProps) => {
        const { 
            vehicles, 
            vehicleGroups 
        } = this.props;

        if ((JSON.stringify(prevProps.vehicles) !== JSON.stringify(vehicles) || JSON.stringify(prevProps.vehicleGroups) !== JSON.stringify(vehicleGroups))
            && Object.keys(vehicles.byId).length
            && Object.keys(vehicleGroups.byVGID).length
        ) {
            this.setUpSelectedVG();
        }
    }

    render() {
        const { 
            isLoading,
            selectedVG, 
        } = this.state;

        const { vehicles } = this.props;

        return (
            <div className = "page-container">
                <Page title = "Edit Vehicle Group">
                    <div style = {{ padding: "30px 20px 0px 20px" }}>
                        <Form className = "login-form" style = {{ marginBottom: 25 }}>
                            <FormItem
                                label = "Group Name"
                                labelCol = {{ span: 7 }}
                                wrapperCol = {{ span: 15 }}
                            >
                                <Input
                                    disabled = {!selectedVG.groupName}
                                    placeholder = "Group Name"
                                    value = {selectedVG.groupName}
                                    onChange = {e =>
                                        this.setState({
                                            selectedVG: {
                                                ...selectedVG,
                                                groupName: e.target.value,
                                            }  
                                        })
                                    }
                                />
                            </FormItem>

                            <FormItem
                                label = "Vehicle Group Color"
                                labelCol = {{ span: 7 }}
                                wrapperCol = {{ span: 15 }}
                            >
                                <div
                                    style = {{
                                        display: "flex",
                                        alignItems: "center",

                                        height: 40,
                                    }}
                                >
                                    <ColorPicker
                                        currHexCode = {this.state.selectedVG.colorHexCode}
                                        presetColors = {VEHICLE_GROUP_COLORS}
                                        onChange = {(color) => {
                                            this.setState({
                                                ...this.state,
                                                selectedVG: {
                                                    ...selectedVG,
                                                    colorHexCode: color.hex.toUpperCase(),
                                                }  
                                            },
                                                () => {
                                                    // console.log("New Color:", this.state.selectedVG.colorHexCode);
                                                }
                                            );
                                        }}
                                    />
                                </div>
                            </FormItem>
                            
                            <FormItem
                                label = "Assign Vehicle(s)"
                                labelCol = {{ span: 7 }}
                                wrapperCol = {{ span: 15 }}
                            >
                                {
                                    Object.values(vehicles.byId).length ?
                                        <Select
                                            disabled = {!(Object.values(vehicles.byId).length)}
                                            mode = "multiple"
                                            placeholder = "Select Vehicles To Add (Optional)"
                                            value = {selectedVG.vehicles && selectedVG.vehicles.length ? selectedVG.vehicles : undefined}
                                            onSearch = {(value) => {
                                                // console.log("Test:", value);

                                                this.setState({ 
                                                    ...this.state,
                                                    searchedVehicleNameString: value
                                                })
                                            }}
                                            onChange = {(value) => {
                                                // console.log("Test:", value);

                                                this.setState({
                                                    selectedVG: {
                                                        ...selectedVG,
                                                        vehicles: value,
                                                    }  
                                                })
                                            }}
                                            style = {{ width: '100%' }}
                                        >
                                            {
                                                Object.values(vehicles.byId)
                                                .filter((currVehicle) => currVehicle.vehicleDisplayName && currVehicle.vehicleDisplayName.toLowerCase().includes(this.state.searchedVehicleNameString.toLowerCase()))
                                                .sort((a, b) => {
                                                    const vA = a.vehicleDisplayName.toLowerCase();
                                                    const vB = b.vehicleDisplayName.toLowerCase();
            
                                                    if (vA < vB) return -1;
                                                    if (vA > vB) return 1;
                                                    return 0;
                                                })
                                                .map((currVehicle) => 
                                                    <Select.Option key = {currVehicle.vid} value = {currVehicle.vid}>
                                                        {currVehicle.vehicleDisplayName}
                                                    </Select.Option>
                                                )
                                            }
                                        </Select> :
                                        <Select
                                            disabled
                                            placeholder = "No Vehicles Found"
                                        />
                                }
                            </FormItem>

                            <div
                                style = {{
                                    display: "flex",
                                    justifyContent: "flex-end",

                                    padding: 5,
                                    marginBottom: 10,
                                }}
                            >
                                <Button
                                    className = "login-form-button"
                                    type = "danger"
                                    disabled = {isLoading}
                                    onClick = {() => this.props.dispatch(goBackToPrev())}
                                    style = {{ marginRight: 10 }}
                                >
                                    Cancel
                                </Button>

                                <PrimaryButton
                                    loading = {isLoading}
                                    onClick = {this.submitForm}
                                >
                                    Edit
                                </PrimaryButton>
                            </div>
                        </Form>
                    </div>
                </Page>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    router: state.router,
    vehicles: state.v2.vehicles,
    vehicleGroups: state.v2.vehicleGroups,
});

const ConnectedAddVehicle = connect(mapStateToProps)(EditVehicleGroup);
export default showSecondarySidebar(false)(ConnectedAddVehicle);